/* eslint-disable prefer-destructuring */
/* eslint-disable no-undef */
import Cookie from "js-cookie";

const updateConversationMedia = (state, { conversation_id, media }) => {
  const updatedConversations = state.conversations.map((conversation) => {
    if (conversation._id === conversation_id) {
      const updatedMedia = [...(Array.isArray(media) ? media : [media])];
      return { ...conversation, media: updatedMedia };
    }
    return conversation;
  });

  // Only update selectedConversation if it matches the updated one
  const updatedSelectedConversation =
    state.selectedConversation._id === conversation_id
      ? {
          ...state.selectedConversation,
          media: [
            ...(Array.isArray(media) ? media : [media]),
            ...(state.selectedConversation.media || []),
          ],
        }
      : { ...state.selectedConversation };

  return {
    ...state,
    conversations: updatedConversations,
    selectedConversation: updatedSelectedConversation,
  };
};

const updateConversationDocs = (state, { conversation_id, docs }) => {
  const updatedConversations = state.conversations.map((con) =>
    con._id === conversation_id ? { ...con, docs } : con,
  );
  const updatedSelectedConversation = { ...state.selectedConversation, docs };
  return {
    ...state,
    conversations: updatedConversations,
    selectedConversation: updatedSelectedConversation,
  };
};

const updateConversationLinks = (state, { conversation_id, links }) => {
  const updatedConversations = state.conversations.map((con) =>
    con._id === conversation_id ? { ...con, links } : con,
  );
  const updatedSelectedConversation = { ...state.selectedConversation, links };
  return {
    ...state,
    conversations: updatedConversations,
    selectedConversation: updatedSelectedConversation,
  };
};

const updateSelectedConversationMessages = (state, { messages, direction, emptyChat }) => {
  const newChatArray =
    state.selectedConversation && state.selectedConversation.chat
      ? direction === "top" || !direction
        ? [...messages, ...state.selectedConversation.chat]
        : [...state.selectedConversation.chat, ...messages]
      : [];

  const updatedChat =
    newChatArray && newChatArray.length && emptyChat === undefined
      ? newChatArray.map((msg, i) => ({
          ...msg,
          isChecked: false,
          index: i + 1,
          // index: i,
        }))
      : messages && emptyChat !== undefined
        ? messages
        : Array.isArray(messages)
          ? messages.map((msg, i) => ({
              ...msg,
              index: i + 1,
            }))
          : [messages];

  return {
    ...state,
    selectedConversation: {
      ...state.selectedConversation,
      chat: updatedChat,
    },
  };
};

const updateSelectedConversationMembers = (state, { members, updatedCoAdmins }) => {
  return {
    ...state,
    selectedConversation: {
      ...state.selectedConversation,
      customer: members,
      co_admins:
        updatedCoAdmins !== undefined ? updatedCoAdmins : state.selectedConversation.co_admins,
    },
  };
};

const patchUserStart = (state) => ({ ...state, patchErrorMsg: "", isLoading: true });

const patchUserSuccess = (state, action) => {
  const copyAction = { ...action };
  delete copyAction.type;
  const localStorageUser = Cookie.getJSON("userInfo");
  const updatedUserCookie = { ...localStorageUser, ...copyAction };
  Cookie.set("userInfo", JSON.stringify(updatedUserCookie));
  return {
    ...state,
    updateUserErrorMsg: "",
    userInfo: { ...state.userInfo, ...copyAction },
  };
};

const patchUserFail = (state, { patchErrorMsg }) => ({ ...state, isLoading: true, patchErrorMsg });

const getUserConversation = (state) => ({ ...state, loading: true });

const getUserConversationSuccess = (state, { userId, conversations, action }) => {
  const canFetchMoreConversation = conversations.length === 10;
  const allConversations = [
    ...state.conversations,
    ...conversations.filter(
      (conv) =>
        !state.conversations.some(
          (existingConv) => existingConv.conversation_id === conv.conversation_id,
        ),
    ),
  ];
  // TODO: check if we can always set allConversations directly
  const newAndOldConversation = action ? [...conversations] : allConversations;

  const pinnedConversations = newAndOldConversation.filter((con) => con.pinned_by.includes(userId));
  const unpinnedConversations = newAndOldConversation.filter(
    (con) => !con.pinned_by.includes(userId),
  );
  // To put pinned conversations at top of the array
  unpinnedConversations.unshift(...pinnedConversations);

  // Rename 'chat' array from back-end
  const renamedPinnedConversation = unpinnedConversations.map((con) => {
    const updatedConversation = {
      ...con,
      lastMessage: (con && con.conversation && con.conversation[0]) || con.lastMessage,
    };
    delete updatedConversation.chat;
    return updatedConversation;
  });

  return {
    ...state,
    loading: false,
    conversations: renamedPinnedConversation,
    conversationsCopy: renamedPinnedConversation,
    constantConversations: renamedPinnedConversation,
    constantConversationsCopy: renamedPinnedConversation,
    errorMsg: false,
    canFetchMoreConversation,
  };
};

const getArchivedConversationSuccess = (state, { archivedConversations }) => {
  return {
    ...state,
    loading: false,
    archivedConversations,
    errorMsg: false,
  };
};

const getUserConversationError = (state, { errorMsg }) => ({
  ...state,
  loading: false,
  errorMsg,
  conversations: [],
});

const setDisplayChat = (state, { value }) => ({ ...state, displayChat: value });

const setSelectedConversation = (state, { selectedConversation }) => {
  // debugger;
  const newIsUpdatingSelectedConversation = !!Object.keys(selectedConversation).length;
  let isUpdating;
  if ("isUpdatingSelectedConversation" in selectedConversation) {
    isUpdating = selectedConversation.isUpdatingSelectedConversation;
  } else isUpdating = newIsUpdatingSelectedConversation;

  return {
    ...state,
    displayChat: true,
    displayCustomerDetails: true,
    showCustomerDetails: false,
    showStarredMessagesBar: false,
    showMediaBar: false,
    showMessageInfoBar: false,
    showSearchBar: false,
    isUpdatingSelectedConversation: isUpdating,
    selectedConversation: {
      ...selectedConversation,
      unreadMessages: 0,
      unreadMessagesCopy: selectedConversation.unreadMessages,
      conversation:
        selectedConversation &&
        selectedConversation.conversation &&
        selectedConversation.conversation.length
          ? selectedConversation.conversation
          : [],
    },
  };
};

const setConversations = (state, { conversations }) => ({ ...state, conversations });

const setConstantConversation = (state, { constantConversations }) => ({
  ...state,
  constantConversations,
});

const setDisplayCustomerDetails = (state, { value }) => ({
  ...state,
  displayCustomerDetails: value,
});

const deleteConversationStart = (state) => ({ ...state, loading: true });

const deleteConversationSuccess = (state, { selectedConversation }) => {
  const filteredConversations = state.conversations.filter(
    (con) => con._id !== selectedConversation.conversation_id,
  );
  return {
    ...state,
    loading: false,
    conversations: filteredConversations,
  };
};

const deleteConversationFail = (state) => ({ ...state, loading: true });

const logoutStart = (state) => ({ ...state, loading: true });

const logoutSuccess = (state) => ({
  ...state,
  loading: false,
  errorMsg: "",
  userInfo: {},
  conversations: [],
  constantConversations: [],
  constantConversationsCopy: [],
  conversationsCopy: [],
  isLoggedIn: false,
});

const logoutFail = (state, { errorMsg }) => ({ ...state, loading: false, errorMsg });

const registerStart = (state) => ({ ...state, loading: true });

const registerSuccess = (state) => ({
  ...state,
  loading: false,
  errorMsg: "",
  registerErrorMsg: "",
});

const registerFail = (state, { errorMsg }) => ({
  ...state,
  loading: false,
  registerErrorMsg: errorMsg,
});

const setSelectedUserCustomers = (state, { selectedUserCustomer }) => ({
  ...state,
  selectedUserCustomer: [...selectedUserCustomer],
});

const updateUserStart = (state) => ({ ...state, updateUserErrorMsg: "", loading: true });

const updateUserSuccess = (state, { updatedUser }) => {
  // const localStorageUser = Cookie.getJSON("userInfo");
  // const updatedUserCookie = { ...localStorageUser, ...updatedUser };
  // Cookie.set("userInfo", JSON.stringify(updatedUserCookie));
  return {
    ...state,
    ...updatedUser,
    userInfo: { ...state.userInfo, ...updatedUser },
  };
};

const updateUserFail = (state, { updateUserErrorMsg }) => ({
  ...state,
  updateUserErrorMsg,
  loading: false,
});

const showFileUploadFunction = (state, { showFileUpload }) => {
  return { ...state, showFileUpload };
};

const setUserVerificationAction = (state, { isUserVerified }) => {
  const localStorageUser = Cookie.getJSON("userInfo");
  const updatedUserCookie = { ...localStorageUser, isUserVerified };
  Cookie.set("userInfo", JSON.stringify(updatedUserCookie));
  return { ...state, userInfo: { ...state.userInfo, isUserVerified } };
};

const sortByLastMessageDate = (array) => {
  return array.sort((a, b) => {
    const nameA = a.conversation[0].date || a.conversation[0].created;
    const nameB = b.conversation[0].date || a.conversation[0].created;
    if (nameA < nameB) {
      return 1;
    }
    if (nameA > nameB) {
      return -1;
    }
    return 0;
  });
};

const updateConversationSuccess = (state, action) => {
  const {
    message,
    setArchived,
    setPinned,
    setRead,
    userId,
    sendMsgFromArchivedChat,
    setExitGroup,
    clearChat,
    setGroupChatClosed,
    newGroupName,
    privacy,
    updatedGroupMembers,
    updatedJoinRequests,
    setMute,
    newGroupAvatar,
    setBlocked,
  } = action;
  const { conversation_id } = message;

  const conversationToUpdate = state.conversations.find(
    (con) => con.conversation_id === conversation_id,
  );

  if (setArchived !== undefined || sendMsgFromArchivedChat === true) {
    if (setArchived === true) {
      const updatedConversations = state.conversations.filter(
        (con) => con.conversation_id !== conversation_id,
      );
      conversationToUpdate.archived_by.push(userId);
      conversationToUpdate.chat = [];

      const archivedConversationsCopy =
        state.archivedConversations && state.archivedConversations.length
          ? [...state.archivedConversations]
          : [];
      archivedConversationsCopy.unshift(conversationToUpdate);
      const sortedArchivedConversations = sortByLastMessageDate(archivedConversationsCopy);
      return {
        ...state,
        loading: false,
        errorMsg: "",
        conversations: updatedConversations,
        conversationsCopy: updatedConversations,
        constantConversations: updatedConversations,
        constantConversationsCopy: updatedConversations,
        archivedConversations: sortedArchivedConversations,
      };
    }
    if (setArchived === false || sendMsgFromArchivedChat !== undefined) {
      const updatedArchivedConversations = state.archivedConversations.filter(
        (con) => con.conversation_id !== conversation_id,
      );
      const pinnedConversations = state.conversations.filter(
        (con) => con.pinned_by.includes(userId) && con.conversation_id !== conversation_id,
      );
      const unpinnedConversations = state.conversations.filter(
        (con) => !con.pinned_by.includes(userId) && con.conversation_id !== conversation_id,
      );
      const archivedConversationToUpdate = state.archivedConversations.find(
        (con) => con.conversation_id === conversation_id,
      );
      unpinnedConversations.push(archivedConversationToUpdate);

      archivedConversationToUpdate.lastMessage = archivedConversationToUpdate.conversation[0];
      archivedConversationToUpdate.chat = [];
      archivedConversationToUpdate.archived_by = archivedConversationToUpdate.archived_by.filter(
        (id) => id !== userId,
      );

      if (sendMsgFromArchivedChat !== undefined) {
        archivedConversationToUpdate.unreadMessages = 0;
        archivedConversationToUpdate.conversation = [message];
      }

      const updatedConversations = [];

      const sortedBinnedConversation = sortByLastMessageDate(pinnedConversations);
      const sortedUnbinnedConversation = sortByLastMessageDate(unpinnedConversations);

      updatedConversations.unshift(...sortedUnbinnedConversation);
      updatedConversations.unshift(...sortedBinnedConversation);

      return {
        ...state,
        loading: false,
        errorMsg: "",
        // selectedConversation:
        //   sendMsgFromArchivedChat !== undefined ? archivedConversationToUpdate : {},
        conversations: updatedConversations,
        conversationsCopy: updatedConversations,
        constantConversations: updatedConversations,
        constantConversationsCopy: updatedConversations,
        archivedConversations: updatedArchivedConversations,
      };
    }
  }

  if (setBlocked !== undefined) {
    const newBlockedValue =
      setBlocked === false
        ? conversationToUpdate?.blocked_by?.concat(userId)
        : conversationToUpdate?.blocked_by?.filter((id) => id !== userId);

    conversationToUpdate.blocked_by = newBlockedValue;

    const updatedConversation = state.conversations.map((con) =>
      con.conversation_id === conversation_id ? conversationToUpdate : con,
    );
    return {
      ...state,
      loading: false,
      errorMsg: "",
      conversations: updatedConversation,
      selectedConversation:
        state.selectedConversation._id === conversation_id
          ? { ...state.selectedConversation, blockedBy: newBlockedValue }
          : state.selectedConversation,
      conversationsCopy: updatedConversation,
      constantConversations: updatedConversation,
      constantConversationsCopy: updatedConversation,
    };
  }

  if (setPinned !== undefined) {
    if (setPinned === true) {
      // 1. Get all pinned and unpinned  conversations
      const pinnedConversations = [
        ...state.conversations.filter((con) => con.pinned_by.includes(userId)),
      ];
      const unpinnedConversations = [
        ...state.conversations.filter(
          (con) => !con.pinned_by.includes(userId) && con.conversation_id !== conversation_id,
        ),
      ];
      // 2. Add new pinned conversation to pinned array
      conversationToUpdate.pinned_by.push(userId);
      pinnedConversations.push(conversationToUpdate);
      // 3. Sort pinned and unpinned conversations
      const sortedPinnedConversations = sortByLastMessageDate(pinnedConversations);
      const sortedUnpinnedConversations = sortByLastMessageDate(unpinnedConversations);
      // 4. Put pinned array at the top of unpinned array
      sortedUnpinnedConversations.unshift(...sortedPinnedConversations);
      return {
        ...state,
        loading: false,
        errorMsg: "",
        conversations: sortedUnpinnedConversations,
        conversationsCopy: sortedUnpinnedConversations,
        constantConversations: sortedUnpinnedConversations,
        constantConversationsCopy: sortedUnpinnedConversations,
      };
    }
    if (setPinned === false) {
      // 1. Get all pinned and unpinned  conversations
      const pinnedConversations = [
        ...state.conversations.filter(
          (con) => con.pinned_by.includes(userId) && con.conversation_id !== conversation_id,
        ),
      ];
      const unpinnedConversations = [
        ...state.conversations.filter((con) => !con.pinned_by.includes(userId)),
      ];
      // 2. Add new unpinned conversation to unpinned array
      conversationToUpdate.pinned_by = conversationToUpdate.pinned_by.filter(
        (con) => con !== userId,
      );
      unpinnedConversations.push(conversationToUpdate);
      // 3. Sort pinned and unpinned conversations
      const sortedPinnedConversations = sortByLastMessageDate(pinnedConversations);
      const sortedUnpinnedConversations = sortByLastMessageDate(unpinnedConversations);
      // 4. Put pinned array at the top of unpinned array
      sortedUnpinnedConversations.unshift(...sortedPinnedConversations);
      return {
        ...state,
        loading: false,
        errorMsg: "",
        conversations: sortedUnpinnedConversations,
        conversationsCopy: sortedUnpinnedConversations,
        constantConversations: sortedUnpinnedConversations,
        constantConversationsCopy: sortedUnpinnedConversations,
      };
    }
  }

  if (setRead !== undefined) {
    if (conversationToUpdate === undefined) {
      const archivedConversationToUpdate = state.archivedConversations.find(
        (con) => con._id === conversation_id,
      );

      if (setRead === true) {
        archivedConversationToUpdate.read_by.push(userId);
        archivedConversationToUpdate.unreadMessages = 0;
      }
      if (setRead === false)
        archivedConversationToUpdate.read_by = archivedConversationToUpdate.read_by.filter(
          (id) => id !== userId,
        );
      const updatedArchivedConversations = state.archivedConversations.map((con) =>
        con._id === conversation_id ? archivedConversationToUpdate : con,
      );

      return {
        ...state,
        loading: false,
        errorMsg: "",
        archivedConversations: updatedArchivedConversations,
      };
    }

    if (setRead === true) {
      conversationToUpdate.read_by.push(userId);
      conversationToUpdate.unreadMessages = 0;
    }
    if (setRead === false)
      conversationToUpdate.read_by = conversationToUpdate.read_by.filter((id) => id !== userId);
    const updatedConversations = state.conversations.map((con) =>
      con._id === conversation_id ? conversationToUpdate : con,
    );
    return {
      ...state,
      loading: false,
      errorMsg: "",
      conversations: updatedConversations,
      conversationsCopy: updatedConversations,
      constantConversations: updatedConversations,
      constantConversationsCopy: updatedConversations,
    };
  }

  if (setMute !== undefined) {
    if (setMute === "unmute") {
      const updatedMutedUsers = conversationToUpdate.muted_by.filter(
        (mu) => mu.user && mu.user.toString() !== userId.toString(),
      );
      conversationToUpdate.muted_by = updatedMutedUsers;
    } else {
      conversationToUpdate.muted_by.push({ user: userId });
    }

    const updatedConversations = state.conversations.map((con) =>
      con._id === conversation_id ? conversationToUpdate : con,
    );
    return {
      ...state,
      loading: false,
      errorMsg: "",
      conversations: updatedConversations,
      conversationsCopy: updatedConversations,
      constantConversations: updatedConversations,
      constantConversationsCopy: updatedConversations,
    };
  }

  if (setExitGroup === true) {
    conversationToUpdate.exit_by.push({ user: userId, date: new Date() });
    const updatedConversation = state.conversations.map((con) =>
      con.conversation_id === conversation_id ? conversationToUpdate : con,
    );
    return {
      ...state,
      loading: false,
      errorMsg: "",
      conversations: updatedConversation,
      conversationsCopy: updatedConversation,
      constantConversations: updatedConversation,
      constantConversationsCopy: updatedConversation,
    };
  }

  if (setGroupChatClosed !== undefined) {
    conversationToUpdate.closed = setGroupChatClosed;
    const updatedConversation = state.conversations.map((con) =>
      con.conversation_id === conversation_id ? conversationToUpdate : con,
    );
    return {
      ...state,
      loading: false,
      errorMsg: "",
      conversations: updatedConversation,
      selectedConversation:
        state.selectedConversation._id === conversation_id
          ? { ...state.selectedConversation, closed: setGroupChatClosed }
          : state.selectedConversation,
      conversationsCopy: updatedConversation,
      constantConversations: updatedConversation,
      constantConversationsCopy: updatedConversation,
    };
  }

  if (newGroupName !== undefined) {
    conversationToUpdate.group_name = newGroupName;
    const updatedConversation = state.conversations.map((con) =>
      con.conversation_id === conversation_id ? conversationToUpdate : con,
    );
    return {
      ...state,
      loading: false,
      errorMsg: "",
      conversations: updatedConversation,
      selectedConversation:
        state.selectedConversation._id === conversation_id
          ? { ...state.selectedConversation, group_name: newGroupName }
          : state.selectedConversation,
      conversationsCopy: updatedConversation,
      constantConversations: updatedConversation,
      constantConversationsCopy: updatedConversation,
    };
  }

  if (newGroupAvatar !== undefined) {
    conversationToUpdate.group_avatar = newGroupAvatar;
    const updatedConversation = state.conversations.map((con) =>
      con.conversation_id === conversation_id ? conversationToUpdate : con,
    );
    return {
      ...state,
      loading: false,
      errorMsg: "",
      conversations: updatedConversation,
      selectedConversation:
        state.selectedConversation._id === conversation_id
          ? { ...state.selectedConversation, group_avatar: newGroupAvatar }
          : state.selectedConversation,
      conversationsCopy: updatedConversation,
      constantConversations: updatedConversation,
      constantConversationsCopy: updatedConversation,
    };
  }

  if (privacy !== undefined) {
    conversationToUpdate.status = privacy;
    const updatedConversation = state.conversations.map((con) =>
      con.conversation_id === conversation_id ? conversationToUpdate : con,
    );
    return {
      ...state,
      loading: false,
      errorMsg: "",
      conversations: updatedConversation,
      selectedConversation:
        state.selectedConversation._id === conversation_id
          ? { ...state.selectedConversation, status: privacy }
          : state.selectedConversation,
      conversationsCopy: updatedConversation,
      constantConversations: updatedConversation,
      constantConversationsCopy: updatedConversation,
    };
  }

  if (clearChat === true) {
    return {
      ...state,
      loading: false,
      errorMsg: "",
      selectedConversation: { ...state.selectedConversation, chat: [] },
    };
  }

  if (updatedJoinRequests) {
    conversationToUpdate.customer = updatedGroupMembers;
    conversationToUpdate.join_requests = updatedJoinRequests;
    const updatedConversation = state.conversations.map((con) =>
      con.conversation_id === conversation_id ? conversationToUpdate : con,
    );
    return {
      ...state,
      loading: false,
      errorMsg: "",
      conversations: updatedConversation,
      selectedConversation:
        state.selectedConversation._id === conversation_id
          ? {
              ...state.selectedConversation,
              customer: updatedGroupMembers,
              join_requests: updatedJoinRequests,
            }
          : state.selectedConversation,
      conversationsCopy: updatedConversation,
      constantConversations: updatedConversation,
      constantConversationsCopy: updatedConversation,
    };
  }
};

const addConversationSuccess = (state, { message, userId, lastMsgId }) => {
  const {
    conversation_id,
    customer,
    subscription_id,
    from,
    type,
    messageType,
    messages_ids,
    conversationType,
    index,
    temp_id,
  } = message;

  const conversationToUpdateId = Array.isArray(conversation_id)
    ? conversation_id[0].conversation_id
    : conversation_id;

  const conversationToUpdate = state.conversations.find(
    (con) =>
      (Array.isArray(con.conversation_id)
        ? con.conversation_id[0].conversation_id
        : con.conversation_id) === conversationToUpdateId,
  );

  // When conversation is not found because the user did not talk with the customer before or it's an archived chat
  if (conversationToUpdate === undefined) {
    const newConversation = {
      conversation_id: conversationToUpdateId,
      customer,
      messages_ids,
      unreadMessages: type === "group" ? 0 : from[0]._id === userId || userId === from ? 0 : 1,
      isArchived: false,
      pinned_by: [],
      archived_by: [],
      deleted_by: [],
      read_by: [userId || from],
      subscription_id,
      conversationType,
      type: conversationType,
      conversation: [{ ...message, messageType: message.type }],
      lastMessage: { ...message, messageType: message.type },
    };

    const pinnedConversations = state.conversations.filter(
      (con) => con.pinned_by.includes(userId) && con.conversation_id !== conversationToUpdateId,
    );

    const unpinnedConversations = state.conversations.filter(
      (con) => !con.pinned_by.includes(userId) && con.conversation_id !== conversationToUpdateId,
    );

    const updatedConversations = [];
    updatedConversations.unshift(...unpinnedConversations);
    updatedConversations.unshift(newConversation);
    updatedConversations.unshift(...pinnedConversations);

    const isMessageAdded =
      state.selectedConversation &&
      state.selectedConversation.chat &&
      state.selectedConversation.chat.find((msg) => messages_ids && messages_ids.includes(msg._id));

    return {
      ...state,
      loading: false,
      errorMsg: "",
      selectedConversation:
        state.selectedConversation &&
        state.selectedConversation.conversation_id === conversationToUpdateId &&
        isMessageAdded === undefined
          ? {
              ...state.selectedConversation,
              chat: state.selectedConversation.chat.concat({
                ...message,
                starred_by: [],
                _id: messages_ids && messages_ids[0],
                type: message.messageType,
                // index:
                //   state.selectedConversation &&
                //   state.selectedConversation.chat &&
                //   state.selectedConversation.chat[state.selectedConversation.chat.length - 1]
                //     .index + 1,
              }),
            }
          : state.selectedConversation,
      conversations: updatedConversations,
      conversationsCopy: updatedConversations,
      constantConversations: updatedConversations,
      constantConversationsCopy: updatedConversations,
    };
  }

  const updatedSelectedConversation = {
    ...conversationToUpdate,
    conversationType: type,
    lastMessage: { ...message, messageType: message.type },
    conversation_id: conversationToUpdateId,
    messageType,
    unreadMessages:
      userId === from[0]._id || userId === from
        ? 0
        : conversationToUpdate.unreadMessages
          ? conversationToUpdate.unreadMessages + 1
          : 1,
    conversation: [
      {
        ...message,
        type: conversationType,
        messageType: message.type,
        starred_by: [],
        index,
      },
    ],
    archived_by: conversationToUpdate.archived_by.filter((id) => id !== userId),
    read_by: [from[0]._id || userId || from],
    starred_by: [],
  };

  const pinnedConversations = state.conversations.filter(
    (con) => con.pinned_by.includes(userId) && con.conversation_id !== conversationToUpdateId,
  );

  const unpinnedConversations = state.conversations.filter(
    (con) => !con.pinned_by.includes(userId) && con.conversation_id !== conversationToUpdateId,
  );

  const updatedConversations = [];

  updatedConversations.unshift(...unpinnedConversations);
  updatedConversations.unshift(updatedSelectedConversation);
  updatedConversations.unshift(...pinnedConversations);

  const messageWithoutId =
    state.selectedConversation &&
    state.selectedConversation.chat &&
    state.selectedConversation.chat.find((msg) => !msg._id && msg.temp_id === temp_id);

  return {
    ...state,
    isUpdatingSelectedConversation: false, // hereeeeeeeeeee
    loading: false,
    errorMsg: "",
    conversations: updatedConversations,
    conversationsCopy: updatedConversations,
    constantConversations: updatedConversations,
    constantConversationsCopy: updatedConversations,
    selectedConversation:
      state.selectedConversation &&
      state.selectedConversation.conversation_id === conversationToUpdateId
        ? lastMsgId !== "" && lastMsgId !== undefined
          ? state.selectedConversation
          : messageWithoutId !== undefined
            ? {
                ...state.selectedConversation,
                chat:
                  state.selectedConversation.chat &&
                  state.selectedConversation.chat.map((item) => {
                    return String(item.temp_id) === String(messageWithoutId.temp_id)
                      ? {
                          ...item,
                          starred_by: [],
                          _id: messages_ids && messages_ids[0],
                          type: message.messageType,
                        }
                      : item;
                  }),
              }
            : {
                ...state.selectedConversation,
                chat:
                  state.selectedConversation &&
                  state.selectedConversation.chat &&
                  state.selectedConversation.chat.concat({
                    ...message,
                    starred_by: [],
                    type: message.messageType || message.type,
                    index:
                      (state.selectedConversation &&
                        state.selectedConversation.chat &&
                        state.selectedConversation.chat &&
                        state.selectedConversation.chat.length &&
                        state.selectedConversation.chat[state.selectedConversation.chat.length - 1]
                          .index + 1) ||
                      1,
                  }),
              }
        : state.selectedConversation,
  };
};

const updateConversationStart = (state) => ({ ...state, loading: true });
const muteConversationStart = (state) => ({ ...state, loading: false });

const updateConversationFail = (state, { errorMsg }) => ({ ...state, loading: false, errorMsg });
const muteConversationFail = (state, { errorMsg }) => ({ ...state, loading: false, errorMsg });

const markCustomerMessagesAsRead = (state, { conversation_id, userId }) => {
  const conversationFromState = state.conversations.find(
    (con) => con.conversation_id === conversation_id,
  );

  if (conversationFromState === undefined) {
    const archivedConversationToUpdate = state.archivedConversations.find(
      (con) => con._id === conversation_id,
    );

    const updatedSelectedConversation = {
      ...archivedConversationToUpdate,
      conversation: archivedConversationToUpdate.conversation || [{ date: "", type: "", body: "" }],
      customer: archivedConversationToUpdate.customer,
      unreadMessages: 0,
      read_by: archivedConversationToUpdate.read_by.concat(userId),
    };

    const updatedArchivedConversations = state.archivedConversations.map((con) =>
      con.conversation_id === conversation_id ? updatedSelectedConversation : con,
    );
    return {
      ...state,
      isUpdatingSelectedConversation: false,
      loading: false,
      errorMsg: "",
      archivedConversations: updatedArchivedConversations,
    };
  }

  const updatedSelectedConversation = {
    ...conversationFromState,
    conversation: conversationFromState.conversation || [{ date: "", type: "", body: "" }],
    customer: conversationFromState.customer,
    unreadMessages: 0,
    read_by: [...conversationFromState.read_by, userId],
  };

  const updatedConversations = state.conversations.map((con) =>
    con.conversation_id === conversation_id ? updatedSelectedConversation : con,
  );
  return {
    ...state,
    isUpdatingSelectedConversation: false,
    loading: false,
    errorMsg: "",
    selectedConversation: { ...state.selectedConversation, ...updatedSelectedConversation },
    conversations: updatedConversations,
    // conversationsCopy: updatedConversations,
    constantConversations: updatedConversations,
    constantConversationsCopy: updatedConversations,
  };
};

const getConversationMediaStart = (state) => {
  return { ...state, getConversationMediaLoading: false, getConversationMediaError: "" };
};

const getConversationMediaFail = (state, { error }) => {
  return { ...state, getConversationMediaLoading: false, getConversationMediaError: error };
};

const setMessageId = (state, { messageId }) => ({ ...state, messageId });

const setConversationData = (state, action) => {
  return {
    ...state,
    conversation: {
      conversationId: action.payload.conversationId,
      customerUserId: action.payload.customerUserId,
    },
  };
};

export {
  updateSelectedConversationMessages,
  markCustomerMessagesAsRead,
  updateConversationFail,
  updateConversationStart,
  setUserVerificationAction,
  getUserConversation,
  getUserConversationSuccess,
  getUserConversationError,
  setDisplayChat,
  setSelectedConversation,
  setConversations,
  setDisplayCustomerDetails,
  deleteConversationStart,
  deleteConversationSuccess,
  deleteConversationFail,
  logoutStart,
  logoutSuccess,
  logoutFail,
  registerStart,
  registerSuccess,
  registerFail,
  setSelectedUserCustomers,
  setConstantConversation,
  updateUserStart,
  updateUserFail,
  updateUserSuccess,
  showFileUploadFunction,
  patchUserStart,
  patchUserSuccess,
  patchUserFail,
  updateConversationSuccess,
  getArchivedConversationSuccess,
  addConversationSuccess,
  updateSelectedConversationMembers,
  updateConversationMedia,
  updateConversationDocs,
  updateConversationLinks,
  getConversationMediaStart,
  getConversationMediaFail,
  muteConversationStart,
  muteConversationFail,
  setMessageId,
  setConversationData,
};
